module.exports = __webpack_public_path__ + "img/65.41436fc0.jpg";